<template>
  <div class="jl-auc-detail-wrap">
    <div class="jl-container">
      <v-breadcrumbs></v-breadcrumbs>
      <div class="jl-auc-dt-top clearfix">
        <div class="jl-acu-dt-left">
          <div class="jl-a-ldt-top">
            <img class="small-img" :src="imgView" alt />
          </div>
          <div class="jl-detail-img-tabs">
            <ul class="jl-d-i-tablist clearfix">
              <li
                :class="[
                  index == imgTabDefaultIndex ? 'item-li active' : 'item-li'
                ]"
                v-for="(item, index) in imglist"
                :key="item.id"
                @mouseenter="enterImgTab(item, index)"
                @click="enterImgTab(item, index)"
              >
                <div class="item-li-box">
                  <img class="small-img" :src="item" alt />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="jl-acu-dt-right">
          <div class="jl-a-d-rbox">
            <p class="text-title">{{ detailObj.name }}</p>
            <div class="jl-a-d-rbox2">
              <p class="text1" v-if="detailType === 0">未开始</p>
              <p class="text1 active" v-else-if="detailType === 1">正在拍卖</p>
              <p class="text1" v-else>已结束</p>

              <p class="text2" v-if="detailType !== 2">
                {{ detailType === 0 ? '距离开始' : '距离结束' }}：
                <span>{{ dd }}</span> 天 <span>{{ hh }}</span> 时
                <span>{{ mm }}</span> 分
              </p>
              <p class="text2" v-else>结束时间：{{ detailObj.endDate }}</p>

              <div
                class="jl-a-d-setlock"
                v-if="detailType === 0"
                @click="setLock"
              >
                <img src="../../../assets/img/zkj-naozhong.png" alt />
                <p class="text3">设置提醒</p>
              </div>
            </div>
            <div class="jl-a-d-rbox3">
              <div class="rb3-item">
                <p class="rb3-text1">起拍价</p>
                <p class="rb3-text2">
                  <span class="span-text0">¥</span>
                  <span class="span-text1">{{ detailObj.startPrice }}</span>
                </p>
                <p class="rb3-text3">
                  (出价
                  <span class="span-color">{{ placardCount }}</span> 次)
                </p>
              </div>
              <div class="rb3-item">
                <p class="rb3-text1" v-if="detailType === 0">一口价</p>
                <p class="rb3-text1" v-if="detailType === 1">当前价</p>
                <p class="rb3-text1" v-if="detailType === 2">成交价</p>
                <p class="rb3-text2">
                  <span class="span-text0 span-color">¥</span>
                  <span class="span-text1 span-color" v-if="detailType === 0">{{
                    detailObj.startPrice
                  }}</span>
                  <span
                    class="span-text1 span-color"
                    v-else-if="detailType === 1"
                    >{{ nowPrice }}</span
                  >
                  <span
                    class="span-text1 span-color"
                    v-else-if="detailType === 2"
                    >{{
                      detailObj.transactionPrice
                        ? detailObj.transactionPrice
                        : 0
                    }}</span
                  >
                </p>
                <p
                  class="rb3-text4-btn"
                  v-if="detailType === 1"
                  @click="refresh"
                >
                  刷新
                  <i
                    :class="[
                      refreshLoading
                        ? 'el-icon-refresh refresh-loading'
                        : 'el-icon-refresh'
                    ]"
                  ></i>
                </p>
              </div>
            </div>
            <div class="jl-a-d-rbox4">
              <ul class="jl-a-d-rb4-list clearfix">
                <li class="rb4-item">
                  <span class="text1">{{ detailObj.remindNumber }}</span>
                  <span class="text2">人设置提醒</span>
                </li>
                <li class="rb4-item">
                  <span class="text1">{{ detailObj.visitorsNumber }}</span>
                  <span class="text2">人浏览</span>
                </li>
                <li class="rb4-item">
                  <span class="text1">{{ detailObj.joinNumber }}</span>
                  <span class="text2">人参与</span>
                </li>
              </ul>
            </div>
            <div class="jl-a-d-rbox5">
              <p class="text1">延时周期：{{ detailObj.delayCycle }}分钟/次</p>
              <p class="text1">
                加价幅度：
                <span class="span-color">{{ detailObj.raisePriceRange }}</span
                >元/次
              </p>
            </div>
            <div class="jl-a-d-rbox6">
              <div class="jl-a-d-rb6-wrap">
                <div class="item alt-1">
                  <div
                    :class="[
                      detailType !== 1 ? 'box alt-left default' : 'box alt-left'
                    ]"
                    @click.stop="showPriceInput"
                  >
                    <span>¥</span>
                    <input
                      v-if="isShowPriceInput"
                      type="text"
                      v-model.trim="auctionPrice"
                      @input="filterInput"
                      id="auctionPrice"
                      class="price-input"
                      @click.stop
                    />
                    <span v-else>{{ auctionPrice }}</span>
                  </div>
                  <div
                    :class="[
                      detailType === 1
                        ? 'box alt-right'
                        : 'box alt-right default-1'
                    ]"
                    @click="handlePlacard"
                  >
                    举牌
                  </div>
                </div>
                <div class="item alt-2" v-if="detailObj.auctionType === 0">
                  <div
                    :class="[
                      detailType === 1
                        ? 'box alt-r-box'
                        : 'box alt-r-box default'
                    ]"
                    @click="handleSpike"
                  >
                    <img
                      v-if="detailType === 1"
                      src="../../../assets/img/zkj-ms.png"
                      alt
                    />
                    <img
                      v-else
                      src="../../../assets/img/zkj-ms-default.png"
                      alt
                    />
                    <span class="text3">秒杀</span>
                  </div>
                </div>
                <p
                  class="spike-deposit"
                  v-if="detailType !== 2 && detailObj.auctionType === 0"
                  @click="payDesopit"
                >
                  支付押金
                </p>
              </div>
              <p class="jl-a-d-rb6-tips">
                当不输入金额时，举牌所出金额为当前价+加价幅度
              </p>
              <p class="jl-a-d-rb6-tips" v-if="detailType !== 2">
                若秒杀，另先支付押金，若已支付，请忽略
              </p>
            </div>
            <v-lastprice
              v-if="detailType !== 0"
              :recordList="recordList"
            ></v-lastprice>
          </div>
        </div>
      </div>
      <div class="jl-auc-d-tabs-wrap">
        <div class="jl-tabs-box">
          <ul class="jl-tabs-list clearfix">
            <template v-for="(item, index) in tabList">
              <li
                :class="[isShowTabIndex === index ? 'item active' : 'item']"
                :data-index="index"
                :key="index"
                v-if="item.isShow"
                @click="handleTabClick(item, index)"
              >
                {{ item.name }}
              </li>
            </template>
          </ul>
        </div>
        <div class="jl-tabs-content">
          <v-description
            v-show="isShowTabIndex === 0"
            :describe="detailObj.describe"
            :videourl="detailObj.videoUrl"
          ></v-description>
          <div v-if="isShowTabIndex === 1" v-html="afterDelivery"></div>
          <div v-if="isShowTabIndex === 2" v-html="auctionProcess"></div>
          <v-record
            v-if="isShowTabIndex === 3"
            :recordList="recordList"
          ></v-record>
        </div>
      </div>
    </div>
    <v-modal-placard
      v-if="isShowPlacard"
      :price="auctionPrice"
      @cancelClick="hanleCancel"
      @confimClick="hanleConfim"
      ref="placard"
    ></v-modal-placard>
    <v-modal-spike
      :seckillPrice="detailObj.seckillPrice"
      ref="modalSpike"
      v-if="isShowSpike"
      @cancelClick="hanleCancel"
      @confimClick="hanleConfim"
    ></v-modal-spike>
    <v-modal-deposit
      v-if="isShowDeposit"
      @cancelClick="hanleCancel"
      @confimClick="hanleConfimPay"
      ref="deposit"
    ></v-modal-deposit>
    <v-modal-pay
      v-if="isShowPay"
      :codeUrl="codeUrl"
      @cancelClick="hanleCancel"
      @confimClick="hanleConfimWechart"
    ></v-modal-pay>
    <div style="display: none;" v-html="payAlipayForm"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '../../../components/Breadcrumbs';
import LastPrice from '../components/LastPrice';
import ModalPlacard from '../components/ModalPlacard';
import ModalSpike from '../components/ModalSpike';
import ModalDeposit from '../components/ModalDeposit';
import ModalPay from '../components/ModalPay';
import Description from '../components/Description';
import Record from '../components/Record';
import {
  auctionDetail,
  auctionDetailAfter,
  setAuctionLock,
  setVisitorsNumber,
  auctionBidRecord,
  placard,
  spike,
  hasSpike,
  getSpikeUser
} from '../../../api/auction';

import { payWechart, payAlipay, checkDepositPay } from '@/api/order';
export default {
  name: 'auctionDetailIndex',
  components: {
    'v-breadcrumbs': Breadcrumbs,
    'v-description': Description,
    'v-record': Record,
    'v-lastprice': LastPrice,
    'v-modal-placard': ModalPlacard,
    'v-modal-spike': ModalSpike,
    'v-modal-deposit': ModalDeposit,
    'v-modal-pay': ModalPay
  },
  data() {
    const detailId = this.$route.query.id;
    const returnUrl = window.location.href;
    return {
      userId: '',
      isShowPlacard: false,
      isShowSpike: false,
      isShowDeposit: false,
      isShowPay: false,
      codeUrl: '',
      payAlipayForm: '',
      isHasSpike: false, //是否拥有秒杀资格
      imgView: '',
      imglist: [],
      imgTabDefaultIndex: 0,
      isShowTabIndex: 0,
      detailType: 0, //拍卖详情状态，0 => 未开始，1 => 正在拍卖，2 => 已结束
      auctionPrice: 0,
      nowPrice: 0, //当前价
      isShowPriceInput: false,
      tabList: [
        {
          name: '拍品描述',
          active: true,
          isShow: true
        },
        {
          name: '发货售后',
          active: false,
          isShow: true
        },
        {
          name: '拍卖流程',
          active: false,
          isShow: true
        },
        {
          name: '出价记录',
          active: false,
          isShow: false
        }
      ],
      detailId: detailId, //拍品id
      detailObj: {
        name: '', //名称
        startPrice: '', //起拍价
        raisePriceRange: '', //加价幅度
        seckillPrice: '', //秒杀价格
        transactionPrice: '', //成交价
        describe: '', //描述

        auctionId: '' //商品id
      },
      dd: '', //天
      hh: '', //时
      mm: '', //分
      ss: '', //秒
      recordList: [], //出价记录
      placardCount: 0, // 出价次数
      refreshLoading: false,
      isDeposit: 1, //isDeposit 是否为押金 0 订单支付  1 押金支付,
      returnUrl: returnUrl, //支付宝提交之后返回的url
      orderId: '',
      timerSetTimeout: null,
      timerSetTimeoutRe: null,
      afterDelivery: '', // 售后
      auctionProcess: '' //拍卖流程
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    $route() {
      this.getdetail();
    }
  },
  created() {
    setVisitorsNumber(this);
    this.userId = this.userInfo.userId;
    this.getdetail();

    // this.refreshData();
    document.body.onclick = () => {
      this.isShowPriceInput = false;
    };
    document.body.onkeyup = e => {
      if (e.keyCode === 13) {
        this.isShowPriceInput = false;
      }
    };
  },
  destroyed() {
    document.body.className = '';
    document.body.onclick = null;
    document.body.onkeyup = null;
    clearTimeout(this.timerSetTimeout);
    clearTimeout(this.timerSetTimeoutRe);
  },
  methods: {
    format(value) {
      //为了兼容ie9时间格式
      if (value) {
        var tt = value.replace(/-/g, '/');
        var time = new Date(tt);
        return time;
      } else {
        return '';
      }
    },
    setTime() {
      let type = this.detailType,
        time = '';
      if (type === 1) {
        time = this.detailObj.endDate
          ? this.detailObj.endDate
          : this.detailObj.expectEndDate;
      } else if (type === 0) {
        time = this.detailObj.startDate;
      }
      let numTime = (this.format(time) - new Date()) / 1000;
      console.log(numTime);
      this.setIntervalTime(numTime);
    },
    setIntervalTime(numTime) {
      let d = parseInt(numTime / (3600 * 24)),
        h = parseInt((numTime - d * 3600 * 24) / 3600),
        m = parseInt((numTime - d * 3600 * 24 - h * 3600) / 60);
      // s = parseFloat(numTime - d * 3600 * 24 - h * 3600 - m * 60);
      this.dd = d < 10 ? '0' + d : d;
      this.hh = h < 10 ? '0' + h : h;
      this.mm = m < 10 ? '0' + m : m;
      // this.ss = s < 10 ? "0" + s : s;
      numTime -= 1;
      if (numTime < 0) {
        /* if (this.detailType === 0) {
          //倒计时结束，状态是未开始
          let tt =
            (this.format(this.detailObj.expectEndDate) - new Date()) / 1000;
          
          setTimeout(() => {
            this.detailType = 1;
            this.setIntervalTime(tt);
          }, 1000);
        } else if (this.detailType === 1) {
          //倒计时结束，状态是正在进行中
          this.detailType = 2;
        } */
        clearTimeout(this.timerSetTimeout);
        clearTimeout(this.timerSetTimeoutRe);
        this.getdetail(this);
      } else {
        this.timerSetTimeout = setTimeout(() => {
          this.setIntervalTime(numTime);
        }, 1000);
      }
    },
    setLock() {
      //设置提醒
      if (this.detailType === 0) {
        if (!this.userInfo.phone) {
          this.$confirm('您尚未绑定手机', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$router.push({
                name: 'accountInformation'
              });
            })
            .catch(() => {
              console.log('取消');
            });
        } else {
          setAuctionLock(this, res => {
            if (res.code == 200) {
              this.refresh();
            }
          });
        }
      }
    },
    //过滤金额输入
    filterInput() {
      this.auctionPrice = this.auctionPrice.match(/\d+(\.\d{0,2})?/)
        ? this.auctionPrice.match(/\d+(\.\d{0,2})?/)[0]
        : '';
      this.auctionPrice = this.auctionPrice
        ? parseFloat(this.auctionPrice).toString()
        : '';
    },

    showPriceInput(e) {
      //点击显示竞拍价格输入框
      if (this.detailType !== 1) return;
      this.isShowPriceInput = true;
      this.$nextTick(() => {
        document.getElementById('auctionPrice').focus();
      });
    },
    handleTabClick(item, index) {
      //切换
      this.isShowTabIndex = index;
      /* if (e.target.nodeName.toLowerCase() === "li") {
        const index = parseFloat(e.target.getAttribute("data-index"));
        this.isShowTabIndex = index;
        this.tabList = this.tabList.map((item, i) => {
          item.active = index === i ? true : false;
          return item;
        });
      } */
    },
    getdetail() {
      //获取详情
      clearTimeout(this.timerSetTimeout);
      clearTimeout(this.timerSetTimeoutRe);
      auctionDetail(this, () => {
        /* //检测用户是否拥有秒杀资格 并且拍品是秒杀拍品
        if (this.userInfo.userId && this.detailObj.auctionType === 0) {
          // hasSpike(this);
        } */
        /* //登录模态框触发事件
        this.$bus.$on("checkDepositType", res => {
          // hasSpike(this);
        }); */
      });
    },
    enterImgTab(item, index) {
      //pc端鼠标移入小图标
      this.imgView = item;
      this.imgTabDefaultIndex = index;
    },
    handlePlacard() {
      //举牌
      var boolphone = this.hasPhone();
      if (!boolphone) return;
      if (this.detailType !== 1) return;
      // this.checkLoginFn(vm => {

      if (this.recordList.length == 0) {
        let n1 =
          parseFloat(this.auctionPrice) - parseFloat(this.detailObj.startPrice);
        //console.log(this.auctionPrice);
        //console.log(this.detailObj.startPrice);
        if (n1 < 0) {
          this.$notify({
            title: '提示',
            message: '举牌金额要大于起拍价格',
            type: 'warning'
          });
          return;
        }
      } else {
        let n =
          parseFloat(this.auctionPrice) -
          parseFloat(this.nowPrice) -
          parseFloat(this.detailObj.raisePriceRange);
        if (n < 0) {
          this.$notify({
            title: '提示',
            message: '举牌金额要大于(当前价+加价幅度)',
            type: 'warning'
          });
          return;
        }
      }

      this.isShowPlacard = true;
      document.body.className = 'overActive';

      // });
    },
    checkLoginFn(cb) {
      if (!this.userInfo.userId) {
        this.$store.dispatch('setShowLoginModel', true);
      } else {
        /* this.$checkLogin({ id: this.userInfo.userId }).then(res => {
          if (res.code === 200) {
            if (res.data === "空") {
              this.$store.dispatch("setShowLoginModel", true);
            } else {
              cb && cb(this);
            }
          }
        }); */
        cb && cb(this);
      }
    },
    //支付押金
    payDesopit() {
      // this.checkLoginFn(vm => {
      hasSpike(this, res => {
        if (this.isHasSpike) {
          this.$notify({
            title: '提示',
            message: '您已支付过押金，无需再支付！可直接秒杀拍品',
            type: 'info'
          });
        } else {
          this.isShowDeposit = true;
          document.body.className = 'overActive';
        }
      });
      // });
    },
    hasPhone() {
      //检测是否绑定手机号
      if (!this.userInfo.phone) {
        this.$confirm('检测到您尚未绑定手机号, 是否绑定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push({
              name: 'informationIndex'
            });
          })
          .catch(() => {
            console.log('取消');
          });
        return false;
      } else {
        return true;
      }
    },
    handleSpike() {
      //秒杀
      var boolphone = this.hasPhone();
      if (!boolphone) return;
      if (this.detailType !== 1) return;
      hasSpike(this, res => {
        if (this.isHasSpike) {
          this.isShowSpike = true;
          document.body.className = 'overActive';
        } else {
          this.$notify({
            title: '提示',
            message: '您尚未支付押金',
            type: 'warning'
          });
        }
      });
    },
    hanleCancel() {
      //取消模态框
      this.isShowPlacard = false;
      this.isShowSpike = false;
      this.isShowDeposit = false;
      this.isShowPay = false;
      document.body.className = '';
    },
    //获取秒杀用户
    getSpikeUser() {
      setTimeout(() => {
        getSpikeUser(this, res => {
          if (res.code != 200) {
            this.getSpikeUser();
          } else {
            if (res.code == 200) {
              this.$refs.modalSpike.isShowLoading = false;
              this.isShowSpike = false;
              if (res.data.userId == this.userInfo.userId) {
                //秒杀成功
                this.$notify({
                  title: '提示',
                  message: '秒杀成功',
                  type: 'success'
                });
                this.$router.push({
                  name: 'auctionDetailSuccess',
                  query: {
                    id: this.$route.query.id
                  }
                });
              } else {
                this.$notify({
                  title: '提示',
                  message: '秒杀失败，该拍品已被拍下',
                  type: 'error'
                });
              }
            } else {
              this.$notify({
                title: '提示',
                message: '秒杀失败：' + JSON.stringify(res),
                type: 'error'
              });
            }
            clearTimeout(this.timerSetTimeout);
            clearTimeout(this.timerSetTimeoutRe);
            this.getdetail(this);
            document.body.className = '';
          }
        });
      }, 1000);
    },
    hanleConfim(data) {
      //确定举牌 || 秒杀
      if (data.type === 'spike') {
        //秒杀
        if (!this.isHasSpike) {
          this.$notify({
            title: '提示',
            message: '请先支付押金',
            type: 'warning'
          });
          return;
        }
        this.$refs.modalSpike.isShowLoading = true;
        spike(this);
        this.getSpikeUser();
      } else {
        //举牌
        this.auctionPriceCP = data.price;
        placard(this, res => {
          this.$refs.placard.btnloading = false;
          document.body.className = '';
          this.isShowPlacard = false;
          this.refresh();
        });
      }
    },

    hanleConfimPay(data) {
      //押金支付
      if (data.type === 'payAlipay') {
        //支付宝
        this.payPrice = 200;
        this.orderId = this.detailObj.auctionId + this.userInfo.userId; // 为了生成支付宝订单id
        payAlipay(this, res => {
          if (res.code == 200) {
            this.$nextTick(() => {
              this.$refs.deposit.cloading = false;
              document.forms[0].submit();
            });
          }
        });
      } else {
        //微信
        payWechart(this, res => {
          if (res) {
            if (res && res.code_url) {
              this.isShowPlacard = false;
              this.isShowSpike = false;
              this.isShowDeposit = false;
              this.codeUrl = res.code_url;
              this.isShowPay = true;
            }
          }
        });
      }
    },
    hanleConfimWechart() {
      checkDepositPay(this, res => {
        this.isShowPay = false;
        document.body.className = '';
      });
    },

    refresh() {
      clearTimeout(this.timerSetTimeout);
      clearTimeout(this.timerSetTimeoutRe);
      this.refreshLoading = true;
      //手动刷新当期价和出价记录
      this.getdetail();
      // auctionBidRecord(this);
    },

    //10 秒刷新
    refreshData() {
      if (this.detailType != 2) {
        this.timerSetTimeoutRe = setTimeout(() => {
          this.refresh();
        }, 10000);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.jl-auc-detail-wrap {
  background: #f8f8fb;
  padding-bottom: 127px;
  .small-img {
    height: auto;
  }
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-table {
  display: table;
  width: 100%;
  height: 100%;
  text-align: center;
}
.jl-table-cell {
  display: table-cell;
  vertical-align: middle;
}
.jl-auc-dt-top {
  padding: 30px;
  background: #fff;
  box-shadow: 0 0 18px rgba(4, 40, 104, 0.3);
  margin-bottom: 20px;
  .jl-acu-dt-left {
    float: left;
    width: 435px;
    .jl-a-ldt-top {
      position: relative;
      width: 100%;
      height: 580px;
      border: 1px solid #d9d9d9;
      text-align: center;
      overflow: hidden;
      &::after {
        /* content: "";
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%; */
      }
      img {
        /* display: inline-block;
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%; */
        display: block;
        width: 100%;
        transition: all 0.3s;
      }
    }
  }
  .jl-acu-dt-right {
    float: right;
    width: 690px;
    padding-left: 40px;
    .jl-a-d-rbox {
      .text-title {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
      }
    }
    .jl-a-d-rbox2 {
      position: relative;
      margin-bottom: 30px;
      p {
        display: inline-block;
        vertical-align: middle;
      }
      .text1 {
        font-size: 14px;
        color: #c3c3c3;
        padding: 10px 16px;
        border: 1px solid #ebebeb;
        margin-right: 16px;
        background: #f8f8fb;
        &.active {
          color: #e50011;
          border: 1px solid #e50011;
          background: #fff;
        }
      }
      .text2 {
        font-size: 16px;
        color: #999;
        span {
          color: #e50011;
        }
      }
      .jl-a-d-setlock {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        padding-right: 25px;
        padding-left: 30px;
        text-align: center;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 1px;
          height: 100%;
          background-color: #e0e0e0;
        }
        p.text3 {
          display: block;
          font-size: 14px;
          color: #333;
        }
      }
    }
    .jl-a-d-rbox3 {
      padding: 26px 20px;
      background-color: #f8f8fb;
      margin-bottom: 18px;
      .rb3-item {
        margin-bottom: 25px;
        &:last-child {
          margin-bottom: 0;
        }
        p {
          display: inline-block;
          vertical-align: middle;
          color: #333;
          .span-color {
            color: #e50011;
          }
        }
        .rb3-text1 {
          font-size: 16px;
          margin-right: 40px;
        }
        .rb3-text2 {
          font-size: 18px;
          margin-right: 25px;
        }
        .rb3-text4-btn {
          font-size: 12px;
          padding: 2px 5px;
          background: #e50011;
          color: #fff;
          cursor: pointer;
        }
        .span-text0 {
          margin-right: 5px;
        }
        .span-text1 {
          font-size: 32px;
        }
        .rb3-text3 {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .jl-a-d-rbox4 {
      margin-bottom: 16px;
      .jl-a-d-rb4-list {
        .rb4-item {
          position: relative;
          float: left;
          padding: 0 30px;
          font-size: 12px;
          color: #666;
          .text1 {
            color: #e50011;
            margin-right: 5px;
          }
          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 1px;
            height: 100%;
            background-color: #e0e0e0;
          }
          &:first-child:before {
            width: 0;
          }
        }
      }
    }
    .jl-a-d-rbox5 {
      padding: 20px;
      background-color: #fff8f9;
      border: 1px dashed #ffa1a8;
      margin-bottom: 27px;
      .text1 {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        color: #666;
        margin-right: 48px;
        .span-color {
          color: #e50011;
        }
      }
    }
    .jl-a-d-rbox6 {
      margin-bottom: 40px;
      .jl-a-d-rb6-wrap {
        margin-bottom: 13px;
        .item {
          display: inline-block;
          vertical-align: middle;

          .box {
            width: 128px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            &.alt-right {
              display: inline-block;
              vertical-align: middle;
              font-size: 16px;
              color: #fff;
              background-color: #e50011;
              cursor: pointer;
            }
            &.default-1 {
              background-color: #93989d;
              cursor: not-allowed;
            }

            &.alt-left {
              display: inline-block;
              vertical-align: middle;
              border: 1px solid #d6d6d6;
              span {
                font-size: 18px;
                color: #e50011;
                line-height: 20px;
                margin-right: 5px;
              }
              input {
                width: 60%;
                font-size: 18px;
                color: #e50011;
                line-height: 20px;
              }
            }
            &.default {
              cursor: not-allowed;
              span {
                color: #999;
              }
            }
            &.alt-r-box {
              margin-left: 15px;
              border: 1px solid #e50011;
              cursor: pointer;
              img {
                display: inline-block;
                vertical-align: middle;
              }
              .text3 {
                display: inline-block;
                vertical-align: middle;
                font-size: 16px;
                color: #e50011;
                line-height: 16px;
                margin-left: 5px;
              }
            }
            &.default {
              border-color: #93989d;
              cursor: not-allowed;
              .text3 {
                color: #999;
              }
            }
          }
        }
      }
      .jl-a-d-rb6-tips {
        font-size: 14px;
        color: #e50011;
        padding-left: 20px;
        background: url('../../../assets/img/zkj-msw.png') no-repeat left center;
        margin-bottom: 10px;
      }
    }
  }
}
.jl-auc-d-tabs-wrap {
  background: #fff;
  box-shadow: 0 0 18px rgba(4, 40, 104, 0.3);
  .jl-tabs-box {
    margin-bottom: 30px;
  }
  .jl-tabs-list {
    border-bottom: 1px solid #e0e0e0;
    .item {
      position: relative;
      float: left;
      width: 172px;
      height: 64px;
      text-align: center;
      line-height: 64px;
      font-size: 18px;
      color: #666;
      border-right: 1px solid #e0e0e0;
      cursor: pointer;
      &:first-child {
        border-left: 0;
      }
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 2px;
        width: 100%;
      }
      &.active:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        height: 2px;
        width: 100%;
        background: #fff;
      }
      &.active:before {
        background-color: #e50011;
      }
    }
  }
  .jl-tabs-content {
    padding: 0 20px;
    padding-bottom: 20px;
    min-height: 500px;
    .jl-auc-img-desc img {
      display: block;
      width: 100%;
    }
  }
}

.jl-detail-img-tabs {
  padding-top: 16px;
  .jl-d-i-tablist {
    margin-left: -8px;
    margin-right: -8px;
    .item-li {
      float: left;
      width: 20%;
      // height: 100px;
      padding: 0 8px;
      margin-bottom: 16px;
      cursor: pointer;
      &.active .item-li-box {
        border-color: #e50011;
      }
    }
    .item-li-box {
      position: relative;
      width: 100%;
      height: 100%;
      border: 1px solid #d9d9d9;
      overflow: hidden;
      text-align: center;
      &::after {
        /* content: "";
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%; */
      }
      img {
        /* display: inline-block;
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%; */
        display: block;
        width: 100%;
      }
    }
  }
  .small-img {
    height: auto;
  }
}

.price-input {
  outline: none;
  &:focus {
    border-bottom: 1px solid #ccc;
  }
}

.refresh-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.spike-deposit {
  display: inline-block;
  vertical-align: bottom;
  line-height: 1;
  font-size: 12px;
  padding: 3px 5px;
  margin-left: 5px;
  background: #e50011;
  color: #fff;
  cursor: pointer;
}

@media screen and (min-width: 1200px) {
  .jl-auc-dt-top .jl-acu-dt-left .jl-a-ldt-top:hover img {
    transform: scale(1.1);
  }
}
</style>
